import * as yup from 'yup';

import { REQUIRED } from '../forms/errorsText.js';

export const validationFields = {
  afterDate: yup.string().required(REQUIRED),
  beforeDate: yup.string().required(REQUIRED),
  storeIdEq: yup.string(),
  byUser: yup.string(),
  stateIn: yup.array(),
  quarantinedReasonIN: yup.array(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (searchParams) => {
  const { q } = searchParams;

  return q;
};
